const setRoles = (state, roles) => state.roles = roles;

let mutations = {
  setRoles
};

export default mutations;
